import UiIcon from '@/components/ui/UiIcon';
import type { ReactNode } from 'react';
import type { MessengerSettingsSection, MessengerSettingsSectionId } from '../../_lib/messengerSettingsConfig';
import { getSettingsSectionTitle } from '../../_lib/messengerSettingsConfig';

type MessengerSettingsPaneProps = {
  activeSectionId: MessengerSettingsSectionId;
  sections: readonly MessengerSettingsSection[];
  chatSettingsLoaded: boolean;
  settingsToast: string | null;
  onSectionChange: (sectionId: MessengerSettingsSectionId) => void;
  children: ReactNode;
};

export function MessengerSettingsPane({
  activeSectionId,
  sections,
  chatSettingsLoaded,
  settingsToast,
  onSectionChange,
  children,
}: MessengerSettingsPaneProps) {
  return (
    <>
      <div className="p-3 sm:p-4 border-b border-site-border-control/40 bg-site-bg/35">
        <div className="text-sm font-semibold text-site-text">{getSettingsSectionTitle(activeSectionId)}</div>
        <div className="text-xs text-site-muted">{chatSettingsLoaded ? 'Настройки мессенджера' : 'Загрузка настроек...'}</div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain p-3 sm:p-4 space-y-4" data-scroll-lock-allow>
        {settingsToast && (
          <div className="px-4 py-2 rounded-xl border border-site-border bg-site-bg/40 text-xs text-site-text">{settingsToast}</div>
        )}

        <div className="lg:hidden">
          <div className="text-xs text-site-muted px-1 uppercase tracking-wider mb-2">Разделы</div>
          <div className="rounded-2xl border border-site-border bg-site-bg/40 backdrop-blur-sm overflow-hidden divide-y divide-site-border">
            {sections.map((section) => (
              <button
                key={section.id}
                type="button"
                onClick={() => onSectionChange(section.id)}
                className={`w-full text-left px-4 py-3 flex items-center gap-3 transition-colors active:bg-site-surface/60 ${
                  activeSectionId === section.id ? 'bg-site-accent/15' : ''
                }`}
              >
                <span className="text-lg">{<UiIcon name={section.icon} />}</span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-site-text">{section.label}</div>
                  <div className="text-xs text-site-muted">{section.desc}</div>
                </div>
                <span className={`text-site-muted transition-transform ${activeSectionId === section.id ? 'rotate-90' : ''}`}>›</span>
              </button>
            ))}
          </div>
        </div>

        {children}
      </div>
    </>
  );
}
